import {UAParser} from 'ua-parser-js';
import {ResolutionUtils} from './resolution-utils';
import {DEVICE_ORIENTATIONS, DEVICE_TYPES, SCREEN_SIZES} from "../../core/consts";
import {BaseUtils} from "./base-utils";

export class DeviceUtils extends BaseUtils {
  isIncognito = false;
  isAdblockActive = null;

  static injectables = [ResolutionUtils];

  constructor(resolutionUtils: ResolutionUtils) {
    super();

    this.resolutionUtils = resolutionUtils;
    this.info = UAParser("user-agent");
    // this.validateAdblock();
  }

  // validateAdblock() {
  //   const adBlockTester = document.createElement('div');
  //   adBlockTester.innerHTML = '&nbsp;';
  //   adBlockTester.className = 'adsbox';
  //   document.body.appendChild(adBlockTester);
  //   window.setTimeout(() => {
  //     this.isAdblockActive = adBlockTester.offsetHeight === 0;
  //
  //     document.body.removeChild(adBlockTester);
  //   }, 60);
  // }

  get deviceType() {
    if (this.resolutionUtils.isLargeView()) {
      const isMediumSized = this.resolutionUtils.resolveScreenSize() === SCREEN_SIZES.md;

      return isMediumSized ? DEVICE_TYPES.tablet : DEVICE_TYPES.desktop;
    }

    if (this.resolutionUtils.isSmallView() || this.resolutionUtils.orientation === DEVICE_ORIENTATIONS.landscape) {
      return DEVICE_TYPES.handset
    }

    return DEVICE_TYPES.tablet;
  }
}
